export default __webpack_public_path__ + "static/media/unsubscribe.f56e45b4.png";